import React, { useState } from 'react';
import { Layout } from '@msanvarov/core-components';
import { Col, Container, Row } from 'reactstrap';
import styles from './CertificatesPage.module.scss';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const CLOUDINARY_BASE_URL = 'https://res.cloudinary.com/dpwglhp5u/image/upload/v1741111580/certificates/';

const CertificatesPage: React.FC = () => {
  const certificates = [
    'https://res.cloudinary.com/deibqsazd/image/upload/v1786897946/Abhishek_Panthee_24-25_Quantum_Certificate_of_Completion_yremko.jpg',
    'c21.jpg', 'c20.jpg', 'c12.jpg', 'c15.jpg', 'c16.png', 'c16_2.jpg', 'c17.jpg', 'c22.jpg', 'c23.jpg', 'c6.jpg',
    'c18.jpg', 'c13.jpg', 'c8.jpg', 'c14.jpg', 'c7.jpg', 'c5.jpg', 'c9.jpg', 'c11.jpg', 'c1.jpg', 'c2.jpg',
    'c3.jpg', 'c4.jpg', 'c10.jpg',
  ];

  const resolveSrc = (certificate: string) =>
    certificate.startsWith('http') ? certificate : `${CLOUDINARY_BASE_URL}${certificate}`;

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const openLightbox = (index: number) => {
    setPhotoIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  return (
    <Layout title='Certificates'>
      <section className={styles['certificates-area']}>
        <Container>
          <div className="about-details" data-aos="zoom-in">
            <h1 className="section-heading" data-aos="fade-up">
              <img src="/assets/star-2.png"alt="Star" className={styles.icon} />
              Certificates
              <img src="/assets/star-2.png"alt="Star" className={styles.icon} />
            </h1>
            <br /><br />
          </div>
          <Row>
            <Col md="12">
              <div className={styles['certificates-grid']}>
                {certificates.map((certificate, index) => (
                  <div
                    className={styles['certificate-item']}
                    key={index}
                    data-aos="zoom-in"
                    onClick={() => openLightbox(index)}
                  >
                    <div className={styles['img-box']}>
                      <img
                        src={resolveSrc(certificate)}
                        alt={`Certificate ${index + 1}`}
                        className={styles['certificate-image']}
                      />
                      <div className={styles['neon-glow']}></div>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {lightboxOpen && (
        <Lightbox
          mainSrc={resolveSrc(certificates[photoIndex])}
          nextSrc={resolveSrc(certificates[(photoIndex + 1) % certificates.length])}
          prevSrc={resolveSrc(certificates[(photoIndex + certificates.length - 1) % certificates.length])}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + certificates.length - 1) % certificates.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % certificates.length)}
        />
      )}
    </Layout>
  );
};

export default CertificatesPage;
